/**
 * resizeScreen
 */

define(
        'resizeScreen',
        ['jquery', 'Seed'],
        function ($, Seed) {
            "use strict";

            /**
             * Fonction permettant de definir la hauteur max d'un element en fonction
             *  de la hauteur passé en paramettre
             * @param {type} item Element à analyser
             * @param {int} height Hauteur
             */
            function parseResizable(item, height)
            {
                //var top = getOffset(item).top;
                var top = $(item).offset().top;
                if (top !== 0) {
                    var footer = $('.navbar-fixed-bottom').height();
                    var newHeight = height - top - 30 - footer;
                    $(item).css('height', newHeight + 'px');
                }
            }

            function resizeScreen()
            {
                // Height
                var height = $(window).outerHeight();
                // Resize globale
                $.each($(".resizable"), function (key, item) {
                    parseResizable(item, height);
                });
            }

            function onWindowResize()
            {
                resizeScreen();
                launchOnHeightResized();
                if (typeof resizeTasks !== "undefined") {
                    resizeTasks();
                }
            }

            var timeoutOnHeightResized;
            var startHeight; // = $(window).height();
            //Fonction permetant du code à la fin d'un changement de hauteur de fenetre
            function launchOnHeightResized()
            {
                //A chaque appel on annule le timeout de la fonction
                clearTimeout(timeoutOnHeightResized);
                timeoutOnHeightResized = setTimeout(function () {
                    //Si on arrive la c'est que cette fonction n'a pas été annulé
                    // dans le temps impartit
                    //Definition de la nouvelle
                    // hauteur.
                    startHeight = $(window).height();
                    //// On place ici tous code devant etre appeler a la fin d'un resize
                    // de la hauteur de la fenetre
                    if (typeof kendo !== "undefined") {
                        // Fonction Kendo
                        resizeScreenKendo();
                    }
                    //}
                }, 150);
            }

            /**
             * Obtenir la position exact d'un élément
             * @param {type} el Element à analyser
             * @returns {Object} Position de l'élément
             */
            function getOffset(el)
            {
                var _x = 0;
                var _y = 0;
                while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
                    _x += el.offsetLeft - el.scrollLeft;
                    _y += el.offsetTop - el.scrollTop;
                    el = el.offsetParent;
                }
                return {top: _y, left: _x};
            }


            //    exposed public method
            return {
                onWindowResize: onWindowResize,
                launchOnHeightResized: launchOnHeightResized,
                resizeScreen: resizeScreen
            };
        },
        function (err) {
            console.error("ERROR: ", err.requireType);
            console.error("MODULES: ", err.requireModules);
        }
);
